const FallbackFonts = `'Helvetica', 'Arial', 'sans-serif'`;

const FontGraphie = (fontSize, lineHeightIndex, fontWeight, letterSpacing) => {
  return `
    font-weight: ${fontWeight*100};
    line-height: ${lineHeightIndex ? fontSize*lineHeightIndex : fontSize + 4}rem;
    font-size: ${fontSize}rem;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: ${letterSpacing ? letterSpacing : `normal`};
    font-family: Graphie, ${FallbackFonts}; 
  `
}

export default FontGraphie;